<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-card title="Team Info">
          <template v-slot:append>
            <v-icon icon="mdi-pencil" @click="isTeamEditOpen = !isTeamEditOpen"></v-icon>
            <v-tooltip activator="parent" location="end">Edit Team</v-tooltip>
          </template>
          <v-card-text>
            <ChangeBranchComponent
              :year-id="yearId"
              :team-id="teamId"
              :branch-id="branchId"
              @snack="throwSnack"></ChangeBranchComponent>

            <TeamViewComponent :team="team"></TeamViewComponent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <AdminTeamLeaderComponent :team-id="teamId" :year-id="yearId"></AdminTeamLeaderComponent>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="isTeamEditOpen">
    <TeamEditComponent
      :team="team"
      :isCreate="false"
      :allow-close="true"
      @team-edit-canceled="isTeamEditOpen = false"
      @teamEditComplete="isTeamEditOpen = false"
      @snack="throwSnack">
    </TeamEditComponent>
  </v-dialog>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { ITeamDTO } from '@/dtos';
import TeamViewComponent from '@/components/teams/TeamViewComponent.vue';
import AdminTeamLeaderComponent from '@/components/teams/admin/AdminTeamLeaderComponent.vue';
import ChangeBranchComponent from '@/components/branches/ChangeBranchComponent.vue';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
import TeamEditComponent from '@/components/teams/TeamEditComponent.vue';

interface Props {
  teamId: string;
  yearId: string;
  team: ITeamDTO;
}
const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  yearId: string;
}
const teamId = computed(() => props.teamId);
const yearId = computed(() => props.yearId);
const team = computed(() => props.team);
const branchId = computed(() => team.value.teamCriteria[0]?.branchYear?.branch?.id ?? '');

const isTeamEditOpen = ref<boolean>(false);
</script>
